module.exports = __webpack_public_path__ + "static/img/412.04c49a47.png";